import { render, staticRenderFns } from "./AdminLimitModal.vue?vue&type=template&id=070f51c8"
import script from "./AdminLimitModal.vue?vue&type=script&lang=js"
export * from "./AdminLimitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070f51c8')) {
      api.createRecord('070f51c8', component.options)
    } else {
      api.reload('070f51c8', component.options)
    }
    module.hot.accept("./AdminLimitModal.vue?vue&type=template&id=070f51c8", function () {
      api.rerender('070f51c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/AdminLimitModal.vue"
export default component.exports